import { type TableParamsType } from '../../types/common';
import { type UseQueryResult, useQuery } from 'react-query';

import {
  TransferAllocateService,
  // eslint-disable-next-line camelcase
  PagedResultDto_GetTransferAllocateDto,
} from '../../services/wealthlane-award-services';

const useGetTransferAndAllocateListForDrs = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  filter: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_GetTransferAllocateDto | undefined,
  unknown
> => {
  const {
    filter: searchKeyWord,
    sorting,
    skipCount,
    maxResultCount,
    name,
    approvalStatusId: containerStatusIds,
  } = tableInfo;
  // const { approvalStatusId: containerStatusIds } = filter;
  const transferAndAllocateListForDrs = useQuery(
    [
      'getTransferAndAllocateListForDrs',
      searchKeyWord,
      sorting,
      skipCount,
      maxResultCount,
      containerStatusIds,
    ],
    async () => {
      return await handleRequest(
        TransferAllocateService.getApiAwardApiAppTransferAllocateTransferAllocateListForDrs(
          sorting,
          skipCount,
          maxResultCount,
          searchKeyWord,
          name,
          containerStatusIds
        )
      );
    },
    {
      select: (data) => {
        if (data != null) {
          return data;
        }
      },
    }
  );

  return transferAndAllocateListForDrs;
};

export default useGetTransferAndAllocateListForDrs;
